import React from 'react';
import styles from './IntegrationsCard.module.scss';
import moment from 'moment';

const Component = ({ item }) => {
  return (
    <div className={styles.item}>
      <span>{item?.checkpointName}:</span>
      <div>
        {item?.operations?.map((i) => (
          <div className={styles.text}>
            {i?.operation} статус:{' '}
            <span className={styles.statusName}>
              {i?.status?.name} {'«Линией»'}
            </span>{' '}
            {moment(i.lastAttemptAt).format('DD.MM.YYYY HH:mm')}
          </div>
        ))}
      </div>
    </div>
  );
};

const IntegrationsCard = ({ data = [] }) => {
  return (
    <div className={styles.root}>
      {data?.map((item, index) => (
        <Component item={item} key={index} />
      ))}
    </div>
  );
};

export default IntegrationsCard;
